<template>
  <div class="public-nav">
    <img class="nav-logo" src="~@/assets/images/logo.png" alt="">
    <div class="nav-item">
      <div class="item-list active">
        <svg  class="item-list-svg" viewBox="362.783 56.267 98.95 32"  preserveAspectRatio="none">
          <path  d="M432.522 68.692c-31.553-10.237-92.403 2.142-58.597 15.173 15.776 6.514 58.597 6.514 69.865-7.82 4.508-5.211-12.77-22.803-42.82-17.59"  stroke-linejoin="round"  stroke-linecap="round"  stroke="currentColor"  fill="transparent" />
        </svg>
        <span>Home</span>
      </div>
      <div class="item-list">
        <svg class="item-list-svg" viewBox="362.783 56.267 98.95 32"  preserveAspectRatio="none">
          <path  d="M432.522 68.692c-31.553-10.237-92.403 2.142-58.597 15.173 15.776 6.514 58.597 6.514 69.865-7.82 4.508-5.211-12.77-22.803-42.82-17.59"  stroke-linejoin="round"  stroke-linecap="round"  stroke="currentColor"  fill="transparent" />
        </svg>
        Pages
      </div>
      <div class="item-list">
        <svg class="item-list-svg" viewBox="362.783 56.267 98.95 32"  preserveAspectRatio="none">
          <path  d="M432.522 68.692c-31.553-10.237-92.403 2.142-58.597 15.173 15.776 6.514 58.597 6.514 69.865-7.82 4.508-5.211-12.77-22.803-42.82-17.59"  stroke-linejoin="round"  stroke-linecap="round"  stroke="currentColor"  fill="transparent" />
        </svg>
        Shop</div>
      <div class="item-list">
        <svg class="item-list-svg" viewBox="362.783 56.267 98.95 32"  preserveAspectRatio="none">
          <path  d="M432.522 68.692c-31.553-10.237-92.403 2.142-58.597 15.173 15.776 6.514 58.597 6.514 69.865-7.82 4.508-5.211-12.77-22.803-42.82-17.59"  stroke-linejoin="round"  stroke-linecap="round"  stroke="currentColor"  fill="transparent" />
        </svg>
        Blog</div>
      <div class="item-list">
        <svg class="item-list-svg" viewBox="362.783 56.267 98.95 32"  preserveAspectRatio="none">
          <path  d="M432.522 68.692c-31.553-10.237-92.403 2.142-58.597 15.173 15.776 6.514 58.597 6.514 69.865-7.82 4.508-5.211-12.77-22.803-42.82-17.59"  stroke-linejoin="round"  stroke-linecap="round"  stroke="currentColor"  fill="transparent" />
        </svg>
        Landing</div>
    </div>
    <div class="nav-user">
      <p class="user-icon">Login</p>
      <p class="user-icon bag">Bag</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'publicNav',
  props: {},
  data () {
    return {}
  },
  components: {},
  computed: {},
  created () {},
  watch: {},
  methods: {}
}
</script>

<style scoped>
.public-nav{display:flex;height:90px;align-items:center;color:#3a4135;font-size:16px;font-weight:400;}
.public-nav .nav-logo{width:140px;}
.public-nav .nav-item{display:grid;gap:20px;grid-template-columns:repeat(5,minmax(0, 1fr));text-align:center;margin:0 auto;}
.public-nav .nav-item .item-list{cursor:pointer;line-height:90px;position:relative;padding:0 10px;}
.nav-user{display:flex;gap:20px;}
.nav-user .user-icon{padding-left:30px;line-height:26px;background: url("~@/assets/images/nav-user.png") left center no-repeat;background-size:20px;}
.nav-user .user-icon.bag{background-image:url('~@/assets/images/nav-shop.png');}
.item-list-svg{position:absolute;top:45%;transform: translate(0,-50%);height:32px;width:84px;left:0px;}
.item-list-svg path{stroke-dasharray:300;stroke-dashoffset:300;transition:stroke-dashoffset 1s ease-out;}
.item-list-svg:hover path{stroke-dashoffset:0;}
.public-nav .nav-item .item-list.active .item-list-svg path{stroke-dashoffset:0;}
</style>
